"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidPath = void 0;
var isValidPath = function (path) {
    return !(!path || path.includes(undefined) || path.includes(null));
};
exports.isValidPath = isValidPath;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXNWYWxpZFBhdGguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZ3JhcGgvaXNWYWxpZFBhdGgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQU8sSUFBTSxXQUFXLEdBQUcsVUFBQyxJQUFTO0lBQ25DLE9BQU8sQ0FBQyxDQUFDLENBQUMsSUFBSSxJQUFJLElBQUksQ0FBQyxRQUFRLENBQUMsU0FBUyxDQUFDLElBQUksSUFBSSxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDO0FBQ3JFLENBQUMsQ0FBQztBQUZXLFFBQUEsV0FBVyxlQUV0QiJ9